import React, { useCallback, useEffect, useMemo } from 'react';
import onClickOutside from 'react-onclickoutside';
import { checkIsCrossCampaignTrackingProperty } from '@browsing/tracking';
import { tracker } from './tracking';
import { find, findPath, getNodesSet } from './helpers';
import ContainerMobile from './ContainerMobile/ContainerMobile';
import ContainerDesktop from './ContainerDesktop/ContainerDesktop';
var FILTER_TAB_NONE = 'SHOW_NONE';
var CATEGORY_TAB_SELECTOR_ID = 'category-tab-selector';
export var CategoryList = function (_a) {
    var selectedCategories = _a.selectedCategories, campaign = _a.campaign, showCategoriesModal = _a.showCategoriesModal, setVisibilityFilter = _a.setVisibilityFilter, allCategories = _a.allCategories, availableCategories = _a.availableCategories, updateFilter = _a.updateFilter, totalArticlesCount = _a.totalArticlesCount, isResetHidden = _a.isResetHidden, disableRootCategoryToggle = _a.disableRootCategoryToggle, isCrossCampaign = _a.isCrossCampaign, onToggleSelection = _a.onToggleSelection, isMyLoungeCrossCampaign = _a.isMyLoungeCrossCampaign;
    useEffect(function () {
        var _a;
        if (!isMyLoungeCrossCampaign) {
            tracker.track('filter_flyout_categories', {
                productCampaign: campaign === null || campaign === void 0 ? void 0 : campaign.campaignIdentifier,
                items: ((_a = allCategories === null || allCategories === void 0 ? void 0 : allCategories.categories) === null || _a === void 0 ? void 0 : _a.length) || 0,
                campaign_level_2: ((allCategories === null || allCategories === void 0 ? void 0 : allCategories.categories) || []).map(function (x) { return x.id; }).join(';'),
                crossCampaignFilter: checkIsCrossCampaignTrackingProperty(isCrossCampaign),
            });
        }
    }, []);
    var closeFilterModal = useCallback(function (shouldSave) { return setVisibilityFilter(FILTER_TAB_NONE, true, shouldSave); }, [setVisibilityFilter]);
    // @ts-ignore
    CategoryList.handleClickOutside = useCallback(function (e) {
        var categoryTabDom = document.getElementById(CATEGORY_TAB_SELECTOR_ID);
        if (categoryTabDom && categoryTabDom.contains(e.target)) {
            return;
        }
        closeFilterModal(false);
    }, []);
    var resetCategoryFilter = useCallback(function () {
        updateFilter({
            categories: [],
        });
        closeFilterModal(false);
    }, []);
    var toggleSelection = useCallback(function (categoryId, depth, isExpanded) {
        var _a;
        if (disableRootCategoryToggle && categoryId === availableCategories.id) {
            return;
        }
        updateFilter({
            categories: [categoryId],
        });
        var category = find(availableCategories, categoryId);
        if (!isMyLoungeCrossCampaign) {
            tracker.track('filter_categories_click', (_a = {
                    productCampaign: campaign === null || campaign === void 0 ? void 0 : campaign.campaignIdentifier,
                    items: (category === null || category === void 0 ? void 0 : category.count) || 0,
                    component: "Level".concat(depth)
                },
                _a["campaign_level_".concat(depth + 1)] = categoryId,
                _a["campaign_level_".concat(depth + 2)] = ((category === null || category === void 0 ? void 0 : category.categories) || [])
                    .map(function (x) { return x.id; })
                    .join(';'),
                _a.crossCampaignFilter = checkIsCrossCampaignTrackingProperty(isCrossCampaign),
                _a));
        }
        onToggleSelection === null || onToggleSelection === void 0 ? void 0 : onToggleSelection(depth, isExpanded);
    }, [availableCategories]);
    var availableCategoriesSet = useMemo(function () { return getNodesSet(availableCategories); }, [availableCategories]);
    var selectedCategoriesSet = useMemo(function () { return new Set(selectedCategories); }, [selectedCategories]);
    var selectedCategoryId = (selectedCategories === null || selectedCategories === void 0 ? void 0 : selectedCategories.length) > 0 ? selectedCategories[0] : null;
    var selectedCategory = selectedCategoryId ? find(allCategories, selectedCategoryId) : null;
    var selectedPath = selectedCategory ? findPath(allCategories, selectedCategory) : [];
    return showCategoriesModal ? (React.createElement(ContainerMobile, { allCategories: availableCategories, campaignId: campaign === null || campaign === void 0 ? void 0 : campaign.campaignIdentifier, resetCategoryFilter: resetCategoryFilter, toggleSelection: toggleSelection, selectedPath: selectedPath, selectedCategoriesSet: selectedCategoriesSet, availableCategories: availableCategories, availableCategoriesSet: availableCategoriesSet, count: totalArticlesCount, isResetHidden: isResetHidden, onClose: function () { return closeFilterModal(false); }, onSave: function () { return closeFilterModal(true); }, isCrossCampaign: isCrossCampaign, isMyLoungeCrossCampaign: isMyLoungeCrossCampaign })) : (React.createElement(ContainerDesktop, { allCategories: availableCategories, campaignId: campaign === null || campaign === void 0 ? void 0 : campaign.campaignIdentifier, toggleSelection: toggleSelection, selectedPath: selectedPath, selectedCategoriesSet: selectedCategoriesSet, availableCategoriesSet: availableCategoriesSet, closeFilterModal: function () { return closeFilterModal(false); } }));
};
var clickOutsideConfig = {
    // @ts-ignore
    handleClickOutside: function () { return CategoryList.handleClickOutside; },
};
export default onClickOutside(CategoryList, clickOutsideConfig);
